import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ProtectedRoute } from './components/auth';
import {
  LandingPage,
  LoginPage,
  TelegramLoginPage,
  AcceptInvitePage,
  InboxPage,
  ChannelsPage,
  ConversationAnalysisPage,
  DashboardPage,
  DemoPage,
  KnowledgePage,
  AutoReplySettingsPage,
  ComponentShowcase,
} from './pages';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});


function NotFoundPage(): JSX.Element {
  return (
    <div className="min-h-screen bg-surface-base flex items-center justify-center">
      <div className="text-center">
        <h1 className="font-heading text-6xl font-bold text-accent-ai">404</h1>
        <p className="text-text-secondary mt-4">Страница не найдена</p>
      </div>
    </div>
  );
}

export default function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public routes */}
            <Route path="/landing" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/auth/tg" element={<TelegramLoginPage />} />
            <Route path="/accept-invite" element={<AcceptInvitePage />} />
            <Route path="/demo" element={<DemoPage />} />
            <Route path="/dev/components" element={<ComponentShowcase />} />

            {/* Protected routes */}
            <Route element={<ProtectedRoute />}>
              <Route path="/" element={<Navigate to="/inbox" replace />} />
              <Route path="/inbox" element={<InboxPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/channels" element={<ChannelsPage />} />
              <Route path="/mailboxes" element={<Navigate to="/channels" replace />} />
              <Route path="/analysis/conversations" element={<ConversationAnalysisPage />} />
              <Route path="/knowledge" element={<KnowledgePage />} />
              <Route path="/settings/auto-reply" element={<AutoReplySettingsPage />} />
            </Route>

            {/* 404 */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
